import React from "react";
import courierrLogo from "../../../assets/images/logistics/courierr.png";
import "./style.css";

const indianLogistics = [
  {
    name: "Shiprocket",
    logo: "https://sr-website.shiprocket.in/wp-content/uploads/2023/01/shiprocket_logo.svg"
  },
  {
    name: "Smartship",
    logo: "https://smartship.in/assets/images/logo.png"
  },
  {
    name: "BlueDart",
    logo: "https://www.bluedart.com/image/layout_set_logo?img_id=1414225&t=1758448523813"
  },
  {
    name: "courierr",
    logo: courierrLogo
  }
  // },
  // {
  //   name: "Delhivery",
  //   logo: "https://www.delhivery.com/_nuxt/img/Delhivery_logo.dcef706.png"
  // },
  // {
  //   name: "Xpressbees",
  //   logo: "https://www.xpressbees.com/images/whiteLogo.webp"
  // }
];

export default function Logistics() {
  return (
    <div className="logistics-container">
      <div className="logistics-grid">
        {indianLogistics.map((logistics, index) => (
          <div key={index} className="logistics-card">
            <div className="logistics-logo">
              <img 
                src={logistics.logo} 
                alt={logistics.name}
                onError={(e) => {
                  e.target.src = "../../../assets/images/logistics/";
                }}
              />
            </div>
            <div className="logistics-name">
              <h3>{logistics.name}</h3>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}